// extracted by mini-css-extract-plugin
export default {"supportText":"SupportedPlatformsText-module__supportText_biXr0","mobile-ui":"mobile-ui"};